import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'

export default {
	async [actionTypes.ATA.GESTAO_PEDIDO.NOVO_PEDIDO](context, objParam) {
		const { data } = await api.gestaoPedido.criarNovoPedido(objParam)
		return data
	},
	async [actionTypes.ATA.GESTAO_PEDIDO.BUSCAR_LISTAGEM_PEDIDOS_COLLAPSE]({ state }, busca) {
		let objParams = {
			idAta: { default: null, label: 'idAta', value: busca.filtro.idAta },
			idOrgao: { default: null, label: 'Órgão', value: state.collapse.idOrgao },
			numeroPedido: state.filtro.numeroPedido,
			situacoes: { default: null, label: 'Situações', value: joinFiltroSituacao(busca.filtro) },
		}
		const { data } = await api.gestaoPedido.buscarListagemPedidosCollapse(objParams, busca.paginacao)
		return data
	},
	async [actionTypes.ATA.GESTAO_PEDIDO.BUSCAR_LISTAGEM_PEDIDOS_POR_PROCESSO]({ state }, busca) {
		let objParams = {
			numeroProcesso: { default: null, label: 'numeroProcesso', value: busca.filtro.numeroProcesso },
			idAta: { default: null, label: 'idAta', value: busca.filtro.idAta },
			idOrgao: { default: null, label: 'Órgão', value: busca.filtro.idOrgao },
			situacoes: { default: null, label: 'Situações', value: joinFiltroSituacao(busca.filtro) },
			numeroPedido: state.filtro.numeroPedido,
		}

		const { data } = await api.gestaoPedido.buscarListagemDePedidosPorProcesso(objParams, busca.paginacao)
		return data
	},
}

function joinFiltroSituacao(filtro) {
	return filtro.situacoes && filtro.situacoes.length > 0 ? filtro.situacoes.join(',') : null
}
